<template>
  <div class="page-wrapper">
    <div class="main-container">
      <!-- 左侧菜单栏（可选） -->
      <div class="left-menu">
        <div class="menu-title">党建文化</div>
        <el-menu :default-active="activeMenu" class="el-menu-vertical" @select="handleMenuSelect">
          <el-menu-item index="/dangjian">
            <span>党建动态</span>
          </el-menu-item>
          <el-menu-item index="/dangzhang">
            <span>党章党规</span>
          </el-menu-item>
        </el-menu>
      </div>

      <!-- 右侧内容区 -->
      <div class="right-content">
        <div class="content-container">
          <div class="card">
            <h3 class="org-title">
              {{ pdfTitle }}
            </h3>
            <div class="content-text">
              <iframe 
                :src="pdfUrl" 
                width="100%" 
                height="600px"
                style="border: 1px solid #eee; border-radius: 4px;"
                frameborder="0"
              >
                您的浏览器不支持 PDF 预览，请
                <a :href="pdfUrl" target="_blank">点击下载</a>查看。
              </iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();

const pdfUrl = ref(route.query.url as string);
const pdfTitle = ref(route.query.title as string);
const activeMenu = computed(() => {
  return route.path;
});

const handleMenuSelect = (index: string) => {
  router.push(index);
};
</script>

<style lang="scss" scoped>
.page-wrapper {
  background-color: #f5f7fa;
  /* 整个页面背景色 */
}

.main-container {
  display: flex;
  min-height: calc(100vh - 60px);
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.left-menu {
  width: 220px;
  background: #fff;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.05);
  padding: 20px 0;
  position: sticky;
  margin-top: 20px;
  top: 20px;
  height: fit-content;
  border-radius: 8px;

  .menu-title {
    padding: 0 20px 15px;
    font-size: 20px;
    font-weight: bold;
    color: #1373C0;
    border-bottom: 1px solid #eee;
    margin-bottom: 10px;
  }

  .el-menu-vertical {
    border-right: none;

    :deep(.el-menu-item) {
      height: 46px;
      line-height: 46px;
      font-size: 17px;
      margin: 0 10px;
      border-radius: 4px;

      &.is-active {
        color: #1373C0;
        background-color: #f0f7ff;
      }
    }
  }
}

.right-content {
  flex: 1;
  padding: 20px;
  background-color: #f5f7fa;
  border-radius: 8px;
}

.content-container {
  max-width: 1200px;
  margin: 0 auto;
}

.page-title {
  color: #1373C0;
  font-size: 1.8rem;
  text-align: center;
  margin-bottom: 2.5rem;
  position: relative;
  padding-bottom: 1rem;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 4px;
    background: linear-gradient(90deg, #1373C0, #4da7f0);
    border-radius: 2px;
  }
}

.card {
  padding: 2rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(19, 115, 192, 0.1);
  margin-bottom: 2rem;
}

.org-title {
  color: #1373C0;
  font-size: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;

  .icon {
    width: 32px;
    height: 32px;
    margin-right: 12px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}

.content-text {
  ul.document-list {
    list-style: none;
    padding: 0;
    margin: 0;
    // border: 1px solid #f0f0f0;
    border-radius: 8px;
    overflow: hidden;

    li.document-item {
      position: relative;
      margin: 0;
      padding: 0 0 0 24px;
      /* 左侧留出圆点位置 */
      border-bottom: 1px solid #f0f0f0;

      &:last-child {
        border-bottom: none;
      }

      /* 蓝色圆点样式 */
      &::before {
        content: "";
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
        width: 6px;
        height: 6px;
        background-color: #1373C0;
        border-radius: 50%;
      }

      a.document-link {
        display: block;
        color: #333;
        text-decoration: none;
        font-size: 16px;
        line-height: 1.6;
        padding: 12px 16px 12px 12px;
        /* 右侧留出空间 */
        transition: all 0.25s ease;

        &:hover {
          color: #1373C0;
          font-weight: 500;
          background-color: #f8fafc;
        }
      }
    }
  }
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .content-container {
    width: 95%;
  }
}

@media (max-width: 992px) {
  .left-menu {
    width: 180px;
  }
}

@media (max-width: 768px) {
  .main-container {
    flex-direction: column;
    padding: 0 15px;
  }

  .left-menu {
    width: 100%;
    position: static;
    margin-bottom: 20px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);

    .el-menu-vertical {
      display: flex;
      flex-wrap: wrap;

      :deep(.el-menu-item) {
        flex: 1;
        min-width: 120px;
        margin: 5px;
      }
    }
  }

  .right-content {
    padding: 15px;
  }

  .page-title {
    font-size: 1.5rem;
  }

  .org-title {
    font-size: 1.2rem;

    .icon {
      width: 28px;
      height: 28px;
    }
  }
}

@media (max-width: 480px) {
  .content-text {
    font-size: 0.9rem;
    line-height: 1.8;
  }

  .left-menu .el-menu-vertical :deep(.el-menu-item) {
    font-size: 14px;
    padding: 0 10px;
  }
}
</style>